import React from 'react';
import ReactDOM from 'react-dom/client';
import Parse from 'parse';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { parseConfig } from './parseConfig';

// Initialize Parse
Parse.initialize(parseConfig.APP_ID, parseConfig.JAVASCRIPT_KEY);
Parse.serverURL = parseConfig.URL;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
